import { TransactionApiUrls } from "@/modules/transaction/common/enum";
import type {
  ICreateGroupTransferRequest,
  IGroupTransfer,
  IUpdateGroupTransferRequest,
} from "@/modules/transaction/common/types";
import type { ICommission, IObject } from "@/shared/common/types";
import { generateQuery, withIdempotency } from "@/shared/helpers";
import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "app/axios";

export const groupTransferApi = createApi({
  reducerPath: "groupTransferApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    createGroupTransfer: builder.mutation<string, ICreateGroupTransferRequest>(
      withIdempotency<ICreateGroupTransferRequest>(
        TransactionApiUrls.GroupTransferV2
      )),
    updateGroupTransfer: builder.mutation<string, IUpdateGroupTransferRequest>({
      query: ({ data, id }) => ({
        url: `${TransactionApiUrls.GroupTransferV2}/${id}`,
        method: "PUT",
        data,
      }),
    }),
    getGroupTransfer: builder.query<IGroupTransfer, {
      id: string
    }>({
      query: ({ id }) => ({
        url: `${TransactionApiUrls.GroupTransfer}/${id}`,
      }),
    }),
    getGroupTransferCommission: builder.query<ICommission, IObject>({
      query: (data) => {
        const query = generateQuery(data);
        return ({
          url: `${TransactionApiUrls.GroupTransferCommission}?${query}`,
        });
      },
    }),
  }),
});

export const {
  useCreateGroupTransferMutation,
  useUpdateGroupTransferMutation,
  useGetGroupTransferQuery,
  useLazyGetGroupTransferCommissionQuery,
} = groupTransferApi;
